import React from "react";

const defaultValue = {
  isLoaderShown: false,
  setIsLoaderShown: () => { },
  isIDPInitialized: false,
  /** @var {User} user */
  user: null,
  isSubscribedToAnyService: false,
  language: null,
  menuItems: {},
  noMenuPages: {},
  organizationCode: null,
  disableFlags: [],
};

const GlobalContext = React.createContext(defaultValue);
export default GlobalContext;
